/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RoleType {
    PANEL = 'Panel',
    OPERATOR = 'Operator',
    DRIVER = 'Driver',
    CLIENT = 'Client',
}
